export const ALLOWED_EMAIL_DOMAINS = new Set([
  'gmail.com',
  'googlemail.com',
  'outlook.com',
  'outlook.com.br',
  'hotmail.com',
  'hotmail.com.br',
  'live.com',
  'live.com.br',
  'msn.com',
  'yahoo.com',
  'yahoo.com.br',
  'icloud.com',
  'me.com',
  'mac.com',
  'uol.com.br',
  'bol.com.br',
  'terra.com.br',
  'ig.com.br',
  'proton.me',
  'protonmail.com',
  'aol.com',
  'zoho.com',
  'gmx.com',
  'gmx.net',
  'mail.com',
  'fastmail.com',
]);

export const EMAIL_INVALID_MESSAGE =
  'Informe um e-mail que comece com letra ou número e pertença a um provedor conhecido, como Gmail, Outlook, Hotmail, Yahoo ou iCloud.';

const LOCAL_PART_REGEX = /^[a-z0-9][a-z0-9._+-]*$/i;

export function normalizeEmail(value) {
  return String(value || '').trim().toLowerCase();
}

export function isValidKnownProviderEmail(value) {
  const email = normalizeEmail(value);
  const parts = email.split('@');

  if (parts.length !== 2) return false;

  const [localPart, domain] = parts;
  if (!localPart || localPart.length > 64 || domain.length > 255) return false;
  if (!LOCAL_PART_REGEX.test(localPart)) return false;
  if (localPart.endsWith('.') || localPart.includes('..')) return false;

  return ALLOWED_EMAIL_DOMAINS.has(domain);
}

export function parseKnownProviderEmails(value, existingRecipients = []) {
  const candidates = String(value || '')
    .split(/[\n\s,;]+/)
    .map(item => item.trim())
    .filter(Boolean);
  const existing = new Set(existingRecipients.map(normalizeEmail));
  const valid = [];
  const invalid = [];

  candidates.forEach(candidate => {
    if (!isValidKnownProviderEmail(candidate)) {
      invalid.push(candidate);
      return;
    }

    const normalized = normalizeEmail(candidate);
    if (!existing.has(normalized)) {
      valid.push(normalized);
      existing.add(normalized);
    }
  });

  return { valid, invalid };
}

export function findInvalidEmailRecipients(recipients = []) {
  return recipients
    .filter(recipient => String(recipient).includes('@'))
    .filter(recipient => !isValidKnownProviderEmail(recipient));
}
